import { useReactlytics } from '@americanexpress/reactlytics';
import React from 'react';
import { useSelector } from 'react-redux';
import { getIsLoggedInSelector } from '@americanexpress/travel-selectors';
import {
  AdData, ArticleData, AllArticleData, HotelOfferData, ExploreMoreArticleData,
} from '../../types/PersonalizedMarketingArticles';
import { isAd, isExploreMore, isOffer } from '../../utils/articles';
import { Ad } from './Article/Ad.tsx';
import { HotelOffer } from './Article/HotelOffer.tsx';
import { DefaultArticle } from './Article/DefaultArticle.tsx';
import { ExploreMore } from './Article/ExploreMore.tsx';

export type ArticleWrapperProps = {
  data: AllArticleData,
  analyticsElementPrefix?: string,
  index: number,
  isHorizontal: boolean,
  hasFilters: boolean,
  handleDrawerOpen: () => void,
};

export const ArticleWrapper = ({
  data,
  analyticsElementPrefix,
  index,
  hasFilters,
  isHorizontal,
  handleDrawerOpen,
}: ArticleWrapperProps) => {
  const { track } = useReactlytics();
  const isLoggedIn = useSelector(getIsLoggedInSelector);

  const generateElementIdentifier = (cardName: string) => {
    let elementId = analyticsElementPrefix ? `${analyticsElementPrefix}-${cardName}` : cardName;
    if ('analyticElement' in data && data?.analyticElement) {
      const elementIdSuffix = `-${data.analyticElement.toLowerCase().replace(/\s+/g, '')}`;
      elementId = `${elementId}${isLoggedIn ? '-user' : '-guest'}${elementIdSuffix}`;
    }
    return elementId;
  };

  if (isAd(data)) {
    return (
      <Ad
        ad={data as AdData}
        element={generateElementIdentifier('ad-tile')}
        track={track}
      />
    );
  }

  if (isOffer(data)) {
    return (
      <HotelOffer
        offer={data as HotelOfferData}
        element={generateElementIdentifier(`offer${index + 1}`)}
        isHorizontal={isHorizontal}
        handleDrawerOpen={handleDrawerOpen}
      />
    );
  }

  if (isExploreMore(data)) {
    return (
      <ExploreMore article={data as ExploreMoreArticleData} />
    );
  }

  return (
    <DefaultArticle
      article={data as (ArticleData | ExploreMoreArticleData)}
      element={generateElementIdentifier(`tile${index + 1}`)}
      hasFilters={hasFilters}
      isHorizontal={isHorizontal}
      track={track}
    />
  );
};
